module.exports = __webpack_public_path__ + "static/media/JO.7eeeae91.png";